import analytics, { IdentifyTraits } from '.';
import { getFiGrowthBook } from '../../appview/lib/growthbook';

export function identifyUser(userId: string, traits: IdentifyTraits) {
  analytics.identify(userId, traits);

  getFiGrowthBook().setAttributes();
}

export function resetAnalytics() {
  analytics.reset();
}

export function trackNewsletterSignup(email: string, source: string) {
  analytics.track('email_captured', {
    name: email.toLowerCase(),
    source,
  });
}

export function trackExperimentViewed(name: string, variant: string) {
  analytics.track('User Viewed Experiment', {
    name,
    variant,
  });
}

/**
 * Impression event for the nano upsell offer block.
 *
 * Clickthrough on this step is measured today as taps / `/register/upgrade` pageviews. That
 * pageview disappears when the confirmation and offer screens merge into one, so this event
 * becomes the denominator. It ships ahead of the merge on purpose: running both instruments
 * side by side first means the before/after comparison is same-instrument, rather than
 * comparing pageview-denominated to in-view-denominated rates across the change itself.
 */
export function trackNanoUpsellOfferViewed(properties: { petId: string; gwa: boolean }) {
  analytics.track('Nano Registration > Upsell > Offer Viewed', properties);
}

export function trackClickShopCollarCTA(component: string) {
  analytics.track('Nano Registration > Success > Get the Collar Button', {
    component,
  });
}
